module.exports = __webpack_public_path__ + "img/ic_qrcode_douyin.3e8a7a8.webp";